import { Reducer } from 'redux';
import { TOGGLE_NETWORK_LOADING_SPINNER_VISIBILITY } from './constants';
import { toggleNetworkLoadingSpinnerVisibilityHandler } from './handlers';
import { LoadingSpinnerState, LoadingSpinnerActions, ToggleNetworkLoadingSpinnerVisibilityAction } from './type';

export const initialState: LoadingSpinnerState = {
    visible: false
};

const reducer: Reducer<LoadingSpinnerState> = (state: LoadingSpinnerState = initialState, action: LoadingSpinnerActions) => {
    switch (action.type) {
        case TOGGLE_NETWORK_LOADING_SPINNER_VISIBILITY :
            return toggleNetworkLoadingSpinnerVisibilityHandler(state, action as ToggleNetworkLoadingSpinnerVisibilityAction);

        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/LoadingSpinner/reducer.ts